import { ReactNode } from 'react';

interface DescriptionItemProps {
    /** The decorative icon that is the visible cue of the term (calendar, clock, duration, …). */
    icon: ReactNode;
    label: string;
    /** Screen readers only, for rows where the icon is the only visible cue of what the value is. */
    hideLabel?: boolean;
    children: ReactNode;
    classNames?: string;
    termClassNames?: string;
    detailsClassNames?: string;
}

/**
 * One label/value pair in a <dl>, such as a webinar's date, time or duration: a <dt> with the icon and the label and a
 * <dd> with the value. The <div> groups the pair, which HTML allows inside a <dl>, so a pair wraps as one unit in a
 * flex row and screen readers still hear one description list.
 */
export const DescriptionItem = ({
    icon,
    label,
    hideLabel = false,
    children,
    classNames = '',
    termClassNames = '',
    detailsClassNames = ''
}: DescriptionItemProps) => (
    <div className={classNames}>
        <dt className={termClassNames}>
            {icon}
            {hideLabel ? <span className="sr-only">{label}</span> : label}
        </dt>
        <dd className={detailsClassNames}>{children}</dd>
    </div>
);
